import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip';
import type { MouseEventHandler, ReactNode } from 'react';

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export function Tooltip({ content, children, ariaLabel, className, disabled = false, onClick }: TooltipProps) {
  return (
    <BaseTooltip.Provider>
      <BaseTooltip.Root>
        <BaseTooltip.Trigger
          aria-label={ariaLabel}
          className={className || 'ui-tooltip__trigger'}
          disabled={disabled}
          onClick={onClick}
          render={<button disabled={disabled} />}
          type="button"
        >{children}</BaseTooltip.Trigger>
        <BaseTooltip.Portal>
          <BaseTooltip.Positioner className="ui-positioner">
            <BaseTooltip.Popup className="ui-tooltip__popup">
              {content}
              <BaseTooltip.Arrow className="ui-tooltip__arrow" />
            </BaseTooltip.Popup>
          </BaseTooltip.Positioner>
        </BaseTooltip.Portal>
      </BaseTooltip.Root>
    </BaseTooltip.Provider>
  );
}
